import { createEffect, createEvent } from 'effector'
import { GetTariffsReq, Period, TariffAPI } from '../../services/api/Tafiff'
import { APIResult } from '../../shared/types'
import { HandlerTariff } from './store'

export const setHandlerTariffFx = createEvent<HandlerTariff>()
export const setPeriodFx = createEvent<Period>()

export const getTariffsFx = createEffect<GetTariffsReq, APIResult<typeof TariffAPI['getTariffs']>, APIResult>(
  TariffAPI.getTariffs,
)
